module.exports = __webpack_public_path__ + "img/logo-empower-branco.d775387e.png";